/*
  Life InStyle — "Reserve with a deposit" (snippets/instyle-deposit.liquid).

  Click: add the selected variant with the deposit selling plan, then go
  straight to checkout. A deposit checks out on its own, because Shopify gives
  deferred purchases no pickup or local delivery: if the cart already holds
  other items, say so and stop (the cart guard in the cart footers catches any
  mix made later). If the cart holds only this same reservation, go to checkout
  without adding it twice.

  Size change: Dawn publishes variant-change with the re-rendered section;
  the deposit wrapper's contents are swapped from it, so the amounts and the
  plan follow the selected size.
*/
(() => {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  const showMessage = (box, text, link, html) => {
    const msg = box.querySelector('[data-deposit-msg]');
    if (!msg) return;
    // html is only ever the shop's own limit sentence (theme.liquid: window.instyleCartLimit).
    if (html) msg.innerHTML = html;
    else msg.textContent = text;
    if (link) {
      const a = document.createElement('a');
      a.href = link.href;
      a.className = 'link';
      a.textContent = link.text;
      msg.append(' ', a);
    }
    msg.hidden = false;
  };

  const reserve = async (button) => {
    const box = button.closest('[data-pdp-deposit]');
    if (!box || button.getAttribute('aria-busy') === 'true') return;
    const planId = Number(box.dataset.planId);
    const form = document.getElementById(box.dataset.formId);
    const variantId = Number((form && form.querySelector('input[name="id"]') && form.querySelector('input[name="id"]').value) || box.dataset.variantId);
    const msg = box.querySelector('[data-deposit-msg]');
    if (msg) msg.hidden = true;

    // Online ordering paused (Theme settings > Online ordering): add nothing, say so.
    if (box.dataset.msgPaused) {
      showMessage(box, box.dataset.msgPaused);
      return;
    }

    const spinner = button.querySelector('.loading__spinner');
    button.setAttribute('aria-busy', 'true');
    button.classList.add('loading');
    if (spinner) spinner.classList.remove('hidden');
    try {
      const cart = await (await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } })).json();
      const isThisReservation = (item) =>
        item.variant_id === variantId &&
        item.selling_plan_allocation &&
        item.selling_plan_allocation.selling_plan &&
        item.selling_plan_allocation.selling_plan.id === planId;
      const others = cart.items.filter((item) => !isThisReservation(item));

      if (others.length) {
        showMessage(box, box.dataset.msgCart, { href: `${root}cart`, text: box.dataset.msgCartLink });
        return;
      }

      if (!cart.items.length) {
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1, selling_plan: planId }] }),
        });
        if (!response.ok) {
          // Shopify's own refusal text can carry the stock count, so it is never shown: a 422 gets the
          // shop's one sentence, anything else the generic message.
          if (response.status === 422 && window.instyleCartLimit) {
            showMessage(box, window.instyleCartLimit.text, null, window.instyleCartLimit.html);
          } else {
            showMessage(box, box.dataset.msgError);
          }
          return;
        }
      }

      window.location.href = `${root}checkout`;
    } catch (e) {
      showMessage(box, box.dataset.msgError);
    } finally {
      button.removeAttribute('aria-busy');
      button.classList.remove('loading');
      if (spinner) spinner.classList.add('hidden');
    }
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-deposit-button]');
    if (!button) return;
    event.preventDefault();
    reserve(button);
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const data = event && event.data;
      if (!data || !data.html) return;
      const current = document.getElementById(`InstyleDeposit-${data.sectionId}`);
      const fresh = data.html.getElementById(`InstyleDeposit-${data.sectionId}`);
      if (current && fresh) current.innerHTML = fresh.innerHTML;
    });
  }
})();
